import Splide from '@splidejs/splide';

export default function TestimonialsSlider() {
  const portraitNode = document.getElementById('Portraits');
  const testimonialNode = document.getElementById('Testimonials');

  if (!portraitNode || !testimonialNode) return;

  const globalConfig = {
    autoplay: true,
    interval: 4000,
    arrows: false
  };
  const portrait = new Splide(portraitNode, {
    type: 'fade',
    pagination: false,
    ...globalConfig
  });
  const testimonial = new Splide(testimonialNode, {
    type: 'slide',
    ...globalConfig
  });

  portrait.sync(testimonial);

  portrait.mount();
  testimonial.mount();
}
